import React from 'react';

const AvisoPrivacidadComponent = ({ handleClose }) => {
  return (
    <div>
      <p>
        Este Aviso de Privacidad describe cómo se recopilan, utilizan y comparten tus datos personales al utilizar nuestra aplicación de rifas. Al acceder y utilizar nuestra aplicación, aceptas las prácticas descritas en este aviso.
      </p>

      <h3 style={{ fontWeight: 'bold' }}>1. Información Recopilada:</h3>
      <p>
        Recopilamos información personal, como tu nombre, dirección de correo electrónico y detalles de contacto al crear una cuenta en nuestra aplicación.
        También recopilamos información sobre las rifas en las que participas, incluyendo detalles de compra y participación.
      </p>

      <h3 style={{ fontWeight: 'bold' }}>2. Uso de la Información:</h3>
      <p>
        Utilizamos tu información para:
        <ul>
          <li>Gestionar tu cuenta.</li>
          <li>Procesar tus participaciones en rifas.</li>
          <li>Proporcionarte servicios relacionados.</li>
        </ul>
        Podemos enviar correos electrónicos o notificaciones para informarte sobre nuevas rifas, actualizaciones de la aplicación o promociones especiales (puedes optar por no recibir estos correos en la configuración de tu cuenta).
      </p>

      <h3 style={{ fontWeight: 'bold' }}>3. Compartir la Información:</h3>
      <p>
        No compartimos tu información personal con terceros sin tu consentimiento, excepto cuando sea necesario para proporcionar servicios o cumplir con requisitos legales.
      </p>

      <h3 style={{ fontWeight: 'bold' }}>4. Seguridad:</h3>
      <p>
        Tomamos medidas para proteger tu información personal y garantizar su seguridad. Sin embargo, ten en cuenta que ninguna transmisión por internet o almacenamiento electrónico es 100% seguro.
      </p>

      <h3 style={{ fontWeight: 'bold' }}>5. Acceso y Control:</h3>
      <p>
        Puedes acceder y actualizar tu información personal en la configuración de tu cuenta. Si deseas eliminar tu cuenta, contáctanos y lo haremos de inmediato.
      </p>

      <h3 style={{ fontWeight: 'bold' }}>6. Cambios en la Política de Privacidad:</h3>
      <p>
        Nos reservamos el derecho de actualizar este aviso de privacidad en cualquier momento. Te notificaremos sobre cambios significativos mediante un aviso en nuestra aplicación.
      </p>

      <p>
        Si tienes preguntas sobre este aviso de privacidad, contáctanos en: <a href="mailto:itnext.info@gmail.com">itnext.info@gmail.com</a>.
      </p>
    </div>
  );
};

export default AvisoPrivacidadComponent;
